import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./Loading.module.css";

export const Loading = () => {
  return (
    <div className={styles["loading"]}>
      <FixaSkeleton height="70px" />
      <FixaSkeleton height="70px" />
      <FixaSkeleton height="70px" />
      <FixaSkeleton height="70px" />
    </div>
  );
};
